import {
  SkyscannerMichelinRealtimesavingsV1RealTimeSavings,
  SkyscannerMichelinSearchV1Search,
  SkyscannerMichelinV1Packages,
} from '@skyscanner-internal/michelin-web-http-client';

import { grpcFetchClientWrapper } from '../../internals/clients/grpc/grpc';
import { jhaMiddleware } from '../../internals/clients/grpc/jhaMiddleware';

export const GRPC_MICHELIN_GET_HOTEL_CARHIRE_CLIENT_NAME = 'MICHELIN_GET_HOTEL_CARHIRE';
export const GRPC_MICHELIN_GET_PACKAGES_CLIENT_NAME = 'MICHELIN_GET_PACKAGES';
export const GRPC_MICHELIN_GET_PACKAGES_REAL_TIME_SAVINGS_CLIENT_NAME =
  'MICHELIN_GET_PACKAGES_REAL_TIME_SAVINGS';
export const PATH_PREFIX = '/g/michelin';
const GRPC_MICHELIN_GET_PACKAGES_TIMEOUT = 15_000;
const GRPC_MICHELIN_GET_PACKAGES_REAL_TIME_SAVINGS_TIMEOUT = 15_000;

export const getHotelCarHire = grpcFetchClientWrapper(
  SkyscannerMichelinSearchV1Search.SearchService.Search,
  {
    clientName: GRPC_MICHELIN_GET_HOTEL_CARHIRE_CLIENT_NAME,
    pathPrefix: PATH_PREFIX,
    betaInterceptors: [jhaMiddleware],
  },
);

export const getPackages = grpcFetchClientWrapper(
  SkyscannerMichelinV1Packages.PackagesService.GetPackages,
  {
    clientName: GRPC_MICHELIN_GET_PACKAGES_CLIENT_NAME,
    pathPrefix: PATH_PREFIX,
    timeoutMs: GRPC_MICHELIN_GET_PACKAGES_TIMEOUT,
    betaInterceptors: [jhaMiddleware],
  },
);

export const getPackagesRealTimeSavings = grpcFetchClientWrapper(
  SkyscannerMichelinRealtimesavingsV1RealTimeSavings.RealTimeSavingsService.GetRealTimeSavings,
  {
    clientName: GRPC_MICHELIN_GET_PACKAGES_REAL_TIME_SAVINGS_CLIENT_NAME,
    pathPrefix: PATH_PREFIX,
    timeoutMs: GRPC_MICHELIN_GET_PACKAGES_REAL_TIME_SAVINGS_TIMEOUT,
    betaInterceptors: [jhaMiddleware],
  },
);
